import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { CustomSelect, CustomButton } from 'components/CustomForm';
import { Card, VDivider } from 'components/CommonWidgets';
import { useProvinceSelector, useProvinceDispatch } from 'province-app/redux/province.store';
import { useQuery } from 'react-query';
import {
    handleInputChange,
    goToPage,
    buildFiltersQuery,
    handleCompanyChange,
    handleFilterTypeChange,
    DefaultInputFilter,
    CompFilterType,
    AllCompsFilterType,
    FilterTypeOptions,
} from 'province-app/redux/filter.slice';
import { getCorporations } from 'network/apis/CorporationApi';
import { getStoreReport } from 'network/apis/ReportingApi';
import { getInputs } from 'network/apis/CommonApi';
import { openLink } from 'helpers/general';

const Holder = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
`;

const TopCard = styled(Card)`
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    width: 100%;
    margin-left: 1.5rem;
`;

const ResultBox = styled.div`
	display: grid;
	grid-template-rows: 1fr 1fr;
	row-gap: 0.5rem;

	& > div {
		display: grid;
		grid-template-columns: 1fr 1fr;
		text-align: center;
	}
`;

const Label = styled.span`
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
    direction: rtl;
`;

const StoreTabMenu = ({ tabData }) => {
    const filterState = useProvinceSelector((store) => store.filter);
    const dispatch = useProvinceDispatch();

    const { data: inputsData } = useQuery(
        ["get-inputs"],
        () => getInputs(),
        {
            refetchOnWindowFocus: false,
        }
    );
    const getInputOtions = () => {
        if (inputsData?.data) {
            const inputOptions = inputsData.data.map((input, index) => {
                return { value: input?.item_id, label: input?.name };
            });

            return [DefaultInputFilter, ...inputOptions];
        }

        return [];
    };

    const { data: corporationsData } = useQuery(
        ["get-corporations"],
        () => getCorporations(),
        {
            refetchOnWindowFocus: false,
        }
    );
    const getCorporationsOptions = () => {
        if (corporationsData?.data) {
            const corporationsOptions = corporationsData.data.map((corporation, index) => {
                return { value: corporation?.coop_id, label: corporation?.name };
            });

            return [CompFilterType, ...corporationsOptions];
        }

        return [];
    };

    const getInputsCount = () => `${tabData?.sum ?? 0}`.persianCurrency();
    const getTypesCount = () => `${tabData?.count ?? 0}`.persianCurrency();

    const isCompanyFilterSelected = () => (filterState.selectedFilterType?.value ?? -1) === 0;

    const { refetch: fetchTableExcel } = useQuery(
		["province-export-table-excel", filterState.storesFilterQuery],
		() => getStoreReport(filterState.storesFilterQuery + 'excel=true'),
		{
			refetchOnWindowFocus: false,
			enabled: false,
			onSuccess: (data) => {
				const url = data?.data?.url;
				if (url) openLink(url);
			},
		}
	);

	const downloadTableExcel = () => {
		fetchTableExcel();
	};

    return (
        <Holder>
            <TopCard>
                <CustomButton
                    fontSize={10}
                    onClick={downloadTableExcel}
                    color='#0278EE'
                >
                    اکسل جدول
                </CustomButton>
                <VDivider />
                <ResultBox>
                    <div>
                        <Label>{getInputsCount()} تن</Label>
                        <Label>مجموع نهاده های موجود در انبار :</Label>
                    </div>
                    <div>
                        <Label>{`${getTypesCount()}`} نوع</Label>
                        <Label>انواع نهاده های موجود در انبار :</Label>
                    </div>
                </ResultBox>
                <VDivider />
                <div className="d-flex justify-content-around align-items-center">
                    {isCompanyFilterSelected() && (
                        <CustomSelect
                            placeholder='انتخاب شرکت'
                            className={`ms-2 w-100`}
                            radius="14"
                            options={getCorporationsOptions()}
                            onChange={(newCorporation) => {
                                dispatch(handleCompanyChange(newCorporation));
                                dispatch(buildFiltersQuery());
                            }}
                            value={filterState.selectedCompany}
                            menuPosition='fixed'
                        />
                    )}
                    <CustomSelect
                        className="mx-2 w-100"
                        radius="14"
                        options={[...FilterTypeOptions]}
                        onChange={(newFilter) => {
                            dispatch(handleFilterTypeChange(newFilter));
                            dispatch(buildFiltersQuery());
                        }}
                        value={filterState.selectedFilterType}
                        menuPosition='fixed'
                    />
                    <CustomSelect
                        className="mx-2 w-100"
                        radius="14"
                        options={getInputOtions()}
                        onChange={(newInput) => {
                            dispatch(handleInputChange(newInput));
                            dispatch(buildFiltersQuery());
                        }}
                        value={filterState.selectedInput}
                        menuPosition='fixed'
                    />
                </div>
            </TopCard>
        </Holder>
    );
};

export default StoreTabMenu;
